import { CaseBufferLegend } from "src/components/legend-item/CaseBufferLegend";
import { RegularGridLegend } from "src/components/legend-item/RegularGridLegend";
import { CaseBufferOverlayer } from "src/components/overlayers/CaseBufferOverlayer";
import { RegularGridOverlayer } from "src/components/overlayers/RegularGridOverlayer";
import {
	getDefaultCutoffLowerLimit,
	type Cutoff,
} from "src/hooks/runYearHooks";
import type { Overlayer } from "src/types";

export const GROUPS: { [groupName: string]: Overlayer["group"] } = {
	baseLayers: { name: "baseLayers", type: "radio" },
	result: { name: "result", type: "checkbox" },
	caseConfiguration: { name: "caseConfiguration", type: "checkbox" },
	emissions: { name: "emissions", type: "checkbox" },
	atmostreet: { name: "atmostreet", type: "radio" },
	stations: { name: "stations", type: "checkbox" },
	residentialMaps: { name: "residentialMaps", type: "radio" },
	extraLayers: { name: "extraLayers", type: "checkbox" },
};

export const staticOverlayers: Array<Overlayer> = [
	{
		key: "caseBuffer",
		translationKey: "layer.domain",
		isActive: true,
		opacity: 0.8,
		zIndex: 0,
		component: CaseBufferOverlayer,
		group: GROUPS.caseConfiguration,
		context: ["case-edit", "case-results"],
		layerManager: {
			showFrontLegend: true,
			showBackLegend: false,
			showInLayerManager: true,
		},
		legend: {
			legendType: "component",
			component: () => <CaseBufferLegend />,
		},
	},
	{
		key: "modelDomain",
		translationKey: "layer.regularGrid",
		isActive: false,
		opacity: 0.8,
		zIndex: 0,
		component: RegularGridOverlayer,
		group: GROUPS.caseConfiguration,
		context: ["case-edit", "case-results"],
		layerManager: {
			showFrontLegend: true,
			showBackLegend: false,
			showInLayerManager: true,
		},
		legend: {
			legendType: "component",
			component: () => <RegularGridLegend />,
		},
	},
];

// Run year dependent static overlayers
export function getRunYearStaticOverlayers(
	runYear: number,
	cutoff: number | undefined,
	cutoffList: Cutoff[] | undefined,
): Array<Overlayer> {
	const shouldOmitCutoffFromName = !cutoffList || cutoffList.length === 1;
	const resolvedCutoff = shouldOmitCutoffFromName
		? undefined
		: (cutoff ?? getDefaultCutoffLowerLimit(cutoffList));

	return [
		{
			key: "traffic",
			translationKey: "layer.traffic",
			layers:
				shouldOmitCutoffFromName || resolvedCutoff === undefined
					? `atmoplan:genericroad_${runYear}`
					: `atmoplan:genericroad_${runYear}_${resolvedCutoff}`,
			isActive: false,
			opacity: 0.8,
			zIndex: 0,
			group: GROUPS.emissions,
			url: "/geoserver/wms",
			context: ["case-create", "case-edit", "case-results"],
			layerManager: {
				showFrontLegend: true,
				showBackLegend: false,
				showInLayerManager: true,
			},
			legend: { legendType: "wms" },
		},
		{
			key: "pointsources",
			translationKey: "layer.pointsources",
			layers: `atmoplan:genericpointsource_${runYear}`,
			isActive: false,
			opacity: 0.8,
			zIndex: 0,
			group: GROUPS.emissions,
			url: "/geoserver/wms",
			context: ["case-create", "case-edit", "case-results"],
			layerManager: {
				showFrontLegend: true,
				showBackLegend: false,
				showInLayerManager: true,
			},
			legend: { legendType: "wms" },
		},
	];
}
